import { render, staticRenderFns } from "./ContentBasicsForm.vue?vue&type=template&id=06bb751e&scoped=true&"
import script from "./ContentBasicsForm.vue?vue&type=script&lang=js&"
export * from "./ContentBasicsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContentBasicsForm.vue?vue&type=style&index=0&id=06bb751e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb751e",
  null
  
)

export default component.exports